import { call, put, select,takeLatest } from "redux-saga/effects";

import { API } from "../../api";
import { getBookingAvailability, getBookingAvailabilityFailure, getBookingAvailabilitySuccess } from "../reducers/availabilitiesSlice";

import { errorHandler } from "./common";

function* getAvailabilitySaga (action: any) {
  try {
    const params = action.payload
    console.log("params from saga: ", params)
    // @ts-ignore
    const token = yield select((state) => state.auth.token);
    // @ts-ignore
    const response = yield call<any>(
      API.get,
      `/masters/${params.employeeId}/availability?studioId=${params.studioId}&date=${params.date}`,
      {
        headers: {
          Authorization: `Bearer ${  token}`,
        },
      }
    );

    yield put(getBookingAvailabilitySuccess(response));
  } catch (error: any) {
    yield errorHandler({
      error,
      *recallCallback () {
        yield getAvailabilitySaga(action);
      },
      *callback () {
        yield put(getBookingAvailabilityFailure(error));
      },
    });
  }
}


export function* availabilitySaga () {
  // @ts-ignore
  yield takeLatest(getBookingAvailability().type, getAvailabilitySaga)
}